import { render, staticRenderFns } from "./SelectInsurancePolicyType.vue?vue&type=template&id=0276b07e"
import script from "./SelectInsurancePolicyType.vue?vue&type=script&lang=js"
export * from "./SelectInsurancePolicyType.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports